<ng-container *ngIf="!cardType; else otherTypeCard">
  <div
    class="card"
    [ngStyle]="{
      backgroundImage: 'url(assets/cards/card-bg/' + cardBackground,
      width: cardSize?.width + 'vw',
      height: cardSize?.height + 'vw'
    }"
    [ngClass]="{ disabled: disabled }"
    *ngIf="!isCardAnimation"
  >
    <div class="card-text" [ngStyle]="{ 'font-size': fontSize + 'vw' }">
      <span
        class="acceletator-wrap"
        *ngIf="typeCard === 'ACCELERATOR'; else elseContent"
      >
        {{ acceleratorConfig.firstName }}
        <span
          [ngStyle]="{ 'font-size': acceleratorConfig.fontSizeTime + 'vw' }"
          class="acceletator-text"
        >
          {{ acceleratorConfig.secondName }}
        </span>
      </span>
      <ng-template #elseContent>
        {{ cardTitle }}
      </ng-template>
    </div>
    <img
      class="card-element"
      src="{{
        centerElement
          ? 'assets/cards/card-component/' + centerElement
          : 'assets/cards/card-component/no-pictures.png'
      }}"
    />
    <div class="grade-effect-content">
      <div class="left">
        <img
          *ngIf="leftIcon"
          [src]="'assets/cards/card-grades/' + leftIcon"
          [ngStyle]="{ width: cardSize?.iconSize + 'vw' }"
        />
      </div>
      <div class="right">
        <img
          *ngIf="rightIcon"
          [src]="'assets/cards/card-effects/' + rightIcon"
          [ngStyle]="{ width: cardSize?.iconSize + 'vw' }"
        />
      </div>
    </div>
  </div>
  <div
    *ngIf="
      (multiple && multipleCondition === 'TRANSFORMATION') ||
      (multiple && multipleCondition !== 'COMMON')
    "
    class="x2-icon"
  >
    <div class="x">x</div>
    <div class="number">
      {{ multiple.quantity }}
    </div>
  </div>
  <video
    loop
    muted
    inline
    *ngIf="isCardAnimation"
    (mouseover)="playVideo($event, 'play')"
    (mouseleave)="playVideo($event, 'stop')"
  >
    <source [src]="animationCardImage" type="video/mp4" />
  </video>

  <div
    class="holder"
    *ngIf="cardHolder"
    [ngClass]="{
      small: cardHolder.apiCard.type === 'EXPERIENCE',
      disabled: disabled
    }"
  >
    <div class="exp-value" *ngIf="cardHolder.restoreValue > 1000">
      <app-full-value-popup
        [value]="cardHolder.restoreValue"
      ></app-full-value-popup>
    </div>
    +
    {{ cardHolder.restoreValue | thousandSuff }}
    {{ cardHolder.apiCard.type === "EXPERIENCE" ? "xp." : "" }}
    <img
      *ngIf="cardHolder.apiCard.type === 'ENERGETIC'"
      class="energy-icon"
      src="assets/main-game/modals/EventCardExchanger/TestReward2.png"
      alt=""
    />
  </div>

  <div
    class="card-quantity"
    *ngIf="quanity === 0 || quanity! > 0 || quanity! < 0"
  >
    <div class="card-quantity-value" *ngIf="quanity! > 1000">
      <app-full-value-popup [value]="quanity"></app-full-value-popup>
    </div>
    {{ quanity | thousandSuff }}
  </div>

  <div class="btn-sell" *ngIf="sellPrice">
    <div class="price-holder">
      {{ sellPrice }}
      <img src="assets/main-game/modals/shared/coins.png" />
    </div>
  </div>
</ng-container>

<ng-template #otherTypeCard>
  <div class="card-container {{ cardType }}" *ngIf="cardType !== 'TESTCARD'">
    <p>{{ getContent("displayName") }}</p>
    <img class="main-image" src="{{ getContent('mainImage') }}" alt="" />
    <div class="card-type">
      <img class="type-icon" src="{{ getContent('typeIcon') }}" alt="" />
    </div>
  </div>
</ng-template>
